import { computed, defineComponent } from "vue";
import NavLink from "./NavLink.vue";
export default defineComponent({
    extends: NavLink,
    setup(props) {
        const baseClasses = "text-2xl no-underline block pl-3 pr-4 py-2 border-l-4 border-transparent text-base font-medium text-gray-600 hover:text-gray-800 hover:bg-gray-50 hover:border-gray-300 focus:outline-none focus:text-gray-800 focus:bg-gray-50 focus:border-gray-300 transition duration-150 ease-in-out";
        const activeClasses = "border-round text-2xl no-underline block pl-3 pr-4 py-2 border-l-4 border-indigo-400 text-base font-medium text-white bg-primary focus:outline-none focus:text-indigo-800 focus:bg-indigo-100 focus:border-indigo-700 transition duration-150 ease-in-out";
        const classes = computed(() => {
            return props.active ? activeClasses : baseClasses;
        });
        return {
            classes,
        };
    },
});
